import React, { useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { SankeyController, Flow } from 'chartjs-chart-sankey';

Chart.register(...registerables, SankeyController, Flow);

const SankeyDiagram = ({ data }: { data: { nodes: string[]; links: { source: string; target: string; value: number; tooltip: string }[]; nodeLinkCounts: Record<string, number> } }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const ctx = canvasRef.current?.getContext('2d');
        if (!ctx) return;
        
        // サンキーダイアグラムのデータを設定
        const chartData = {
            datasets: [
                {
                    label: 'Sankey Diagram',
                    data: data.links.map(link => ({
                        from: link.source,
                        to: link.target,
                        flow: link.value,
                        tooltip: link.tooltip,
                    })),
                    colorFrom: () => 'blue',
                    colorTo: () => 'green',
                    colorMode: "gradient" as "gradient",
                    
                    labels: createNodeLabelMap(data.nodes,data.nodeLinkCounts), // ノード名とリンク数を表示
        
                    priority: data.nodes.reduce((acc, node) => {
                        if (node.includes('¥C')) {
                            acc[node] = 0.5; // 中間ノードを中央に配置
                        }
                        if (node.includes('¥B')) {
                            acc[node] = 1; // 中間ノードを中央に配置
                        }
                        if (node.includes('¥A')) {
                            acc[node] = 2; // 中間ノードを中央に配置
                        }
                        if (node.includes('beforeNoData')) {
                            acc[node] = 3; // 中間ノードを中央に配置
                        }
                        if (node.includes('afterNoData')) {
                            acc[node] = 4; // 中間ノードを中央に配置
                        }
                        return acc;
                    }, {} as Record<string, number>),
                   
                },
            ]
        };

        // チャートを描画
        
        const chart = new Chart(ctx, {
            type: 'sankey',
            data: chartData,
            options: {
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: context => {
                                const { from, to, flow, tooltip } = context.raw as { from: string; to: string; flow: number; tooltip: string };
                                return `${tooltip}`; // 一意の識別子を除外
                            },
                        },
                    },
                },
            },
        });
        

        return () => {
            chart.destroy();
        };
    }, [data]);

    const createNodeLabelMap = (nodes: string[], nodeLinkCounts: Record<string, number>) => {
        const nodeLabelMap: Record<string, string> = {};
    
        nodes.forEach(node => {
            const baseName = node.split('¥')[0]; // ノード名の一意の識別子を除外
            const linkCount = nodeLinkCounts[node] || 0; // ノードに繋がるリンク数
            nodeLabelMap[node] = `${baseName}(${linkCount})`; // 連想配列に追加
        });
    
        return nodeLabelMap;
    };

    return <canvas ref={canvasRef} width={800} height={600}></canvas>;
};

export default SankeyDiagram;